import { useDroppable } from '@dnd-kit/core';
import { FC, ReactNode } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    id: string;
    children: ReactNode;
    disabled?: boolean;
    className?: string;
}

// TODO: create story
const DroppableComponent: FC<Props> = ({ id, children, disabled = false, className }) => {
    // Always keep the droppable active for scroll functionality, but use disabled prop for visual state
    const { setNodeRef, isOver: is_over } = useDroppable({ id });

    return (
        <div
            ref={setNodeRef}
            className={cn(
                'rounded-lg',
                className,
                is_over && !disabled && 'ring-2 ring-green-500',
                disabled && 'bg-slate-100 opacity-30'
            )}
        >
            {children}
        </div>
    );
};

export default DroppableComponent;
